export default __webpack_public_path__ + "static/IntroOptimized-b692cfb72f43a73a8b32c7f3b6ca6a10.mp4";